if($('.type-detail').length){
    $('.p-info-wrapper').append('<div class="customCart"></div>');
    if($('.p-info-wrapper .p-final-price-wrapper').length){
        $('.customCart').append($('.p-info-wrapper .p-final-price-wrapper'))
        $('.customCart').append($('.p-info-wrapper .add-to-cart'))
        $('.p-info-wrapper').append('<div class="pointsVizualization"><p>Při koupi <span class="amountProduct">1</span> ks tohoto produktu bude do tvé sítě uvolněno <span class="productPoints"></span>.</p></div>')
    }
    else{
        $('.customCart').html('<strong>Cena je viditelná pouze pro registrované uživatele</strong><a href="/login/" class="btn btn-conversion">Přihlaš se</a>')
    }
    
    if($('.extended-description tr').length>1){
        $('#p-detail-tabs li').first().after('<li class="shp-tab" data-testid="tab" data-width=""><a href="#productParameters" class="shp-tab-link" role="tab" data-toggle="tab">Parametry</a></li>')
        $('#tab-content').append('<div id="productParameters" class="tab-pane fade" role="tabpanel" data-testid="areaParameters">'+$('.extended-description').html()+'</div>')
    }
    $('.p-image-wrapper').append($('.p-detail-info .flags'))
    $('.p-info-wrapper').append($('.p-detail-inner .p-detail-inner-header').clone())
    $('.p-info-wrapper').append($('.p-detail-info .stars-wrapper').clone())
    $('p[data-testid="productCardDescr"] a').text('Číst více')
    if($('.top-navigation-bar .top-navigation-tools a[href="/klient/"]').length){

    }
    else{
        var storedHPText = sessionStorage.getItem('HPText');
        if (storedHPText) {
            $('.p-info-wrapper').append(storedHPText)

        } else {
            loadNewsFromURL()  
        }
    }
    

    function loadNewsFromURL() {
        var url = "/";
        $.get(url, function(data) {
            var $data = $(data);
            var $welcomeText = $data.find(".welcomeText").html();
            $('.p-info-wrapper').append('<div class="welcomeText detailWelcomeText">'+$welcomeText+'</div>')
            sessionStorage.setItem('HPText', '<div class="welcomeText detailWelcomeText">'+$welcomeText+'</div>');
        });
    }



    //vizualizace bodů
    const pageTitle = window.location.hostname;
    const storageName = 'pocetBodu_' + pageTitle.replace(/^www\./, '').split('.')[0];
    $.getJSON('/user/documents/vypocetBodu.json', function(jsonData) {
        if (sessionStorage.getItem(storageName) === null) {
            sessionStorage.setItem(storageName, JSON.stringify(jsonData));
        }
        const storedData = JSON.parse(sessionStorage.getItem(storageName));
        if (storedData) {
           // console.log('Data v sessionStorage:', storedData);
        } else {
           // console.log('Žádná data v sessionStorage.');
        }
        const skuCode = $('meta[itemprop="sku"]').attr('content');
        const product = storedData.find(item => item.product_code === skuCode);
        if (product) {
            $('.pointsVizualization').attr('data-points', product.calculation)
            $('.pointsVizualization span.productPoints').text(product.calculation+' '+sklonovaniBodu(product.calculation))
            
        } else {
            
        }
    }).fail(function() {
        console.error('Chyba při načítání JSON souboru.');
    });


    $(document).on('click', '.add-to-cart .quantity span[role="button"]', function(){
        var inputValue = $(this).closest('.quantity').find('.amount').val()
        var dataPoints = $('.pointsVizualization').attr('data-points')
        mathPoint = Math.ceil(parseFloat(inputValue)*parseFloat(dataPoints))
        $('.pointsVizualization span.productPoints').text(mathPoint+' '+sklonovaniBodu(mathPoint))
        $('.pointsVizualization span.amountProduct').text(inputValue)
    })

 

    function sklonovaniBodu(number) {
        if (number === 1) {
            return "bod";
        } else if (number >= 2 && number <= 4) {
            return "body";
        } else {
            return "bodů";
        }
    }
}